import { IApValues } from "@types"
import { protectedApi } from "store/Api"

const devicesApValues = protectedApi.injectEndpoints({
    endpoints: (builder) => ({
        devicesApValues: builder.query<IApValues[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devices/ap_values`,
                }
            },
        }),
    }),
})

export const { useDevicesApValuesQuery } = devicesApValues
